import { memo, useMemo } from 'react';
import { matchPath, useLocation } from 'react-router-dom';
// material-ui
import { Typography } from '@mui/material';
// project imports
import { getMenuItems } from '@/menu-items';
import NavGroup from './NavGroup';
import { useAppSelector } from '@/hooks';

const HOSPITAL_DETAIL_PATH = '/admin/hospitals/:hospitalId/:detailTab/*';

// ==============================|| SIDEBAR MENU LIST ||============================== //

const MenuList = () => {
    const { pathname } = useLocation();
    const { profile } = useAppSelector((state) => state.profile);
    const { hospitals: userHospitals, currentHospitalId } = useAppSelector(({ hospital }) => hospital);
    const { hospitals: adminHospitals } = useAppSelector(({ hospitalAdmin }) => hospitalAdmin);
    const hospitalId = matchPath(HOSPITAL_DETAIL_PATH, pathname)?.params.hospitalId;
    const activeHospitalId = hospitalId || currentHospitalId || '';

    const scopedHospitalName = useMemo(() => {
        if (!activeHospitalId) {
            return '';
        }

        return (
            adminHospitals.find((hospital) => hospital.id === activeHospitalId)?.name ||
            userHospitals.find((hospital) => hospital.id === activeHospitalId)?.name ||
            ''
        );
    }, [activeHospitalId, adminHospitals, userHospitals]);

    const navItems = useMemo(() => {
        const { items } = getMenuItems({
            hospitalId,
            hospitalName: scopedHospitalName,
            user: profile
        });

        return items.map((item) =>
            item.type === 'group' ? (
                <NavGroup key={item.id} item={item} lastItem={0} remItems={[]} lastItemId="" />
            ) : (
                <Typography key={item.id} variant="h6" color="error" align="center">
                    Menu Items Error
                </Typography>
            )
        );
    }, [hospitalId, profile, scopedHospitalName]);

    return navItems;
};

export default memo(MenuList);
